import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

import { PuSubscribable } from '@app/utils/pu-subscribe';
import { RestProjectTypeModel } from '@main-application/management/pages/service-configuration/project-types/project-types.interface';
import { InputModule } from '@ui-components/controls/input/input.module';

@Component({
  standalone: true,
  selector: 'app-add-project-type-dialog',
  templateUrl: './add-project-type-dialog.component.html',
  styleUrls: ['./add-project-type-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, ReactiveFormsModule, InputModule, MatDialogModule, MatButtonModule],
})
export class AddProjectTypeDialogComponent extends PuSubscribable implements OnInit {
  private cdr: ChangeDetectorRef = inject(ChangeDetectorRef);
  private formBuilder: FormBuilder = inject(FormBuilder);
  private dialogRef: MatDialogRef<AddProjectTypeDialogComponent> = inject(MatDialogRef);

  public data: RestProjectTypeModel & { title?: string } = inject(MAT_DIALOG_DATA);
  form = this.formBuilder.group({
    name: [null],
  });
  submitted = false;
  title = this.data?.title ? this.data.title : this.data ? 'Edit Project Type' : 'Add Project Type';

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.initForm();
  }

  close() {
    this.dialogRef.close();
  }

  save() {
    this.submitted = true;
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.cdr.detectChanges();
      return;
    }

    const { name } = this.form.value;
    this.dialogRef.close({ name: name.trim() });
  }

  private initForm() {
    this.form = this.formBuilder.group({
      name: [this.data?.name || null, [Validators.required]],
    });
  }
}
